import { ShieldAlert } from "lucide-react";

interface NoAccessProps {
  message?: string;
}

/** Friendly empty-state shown when the backend denies data access (RBAC 403). */
export function NoAccess({
  message = "You don't have access to this data. Please reach out to your administrator.",
}: NoAccessProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border py-16 text-center">
      <div className="mb-4 rounded-full bg-secondary p-3">
        <ShieldAlert className="h-6 w-6 text-secondary-foreground" aria-hidden />
      </div>
      <p className="max-w-sm text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
